/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-24 10:42:23
 * @LastEditTime: 2025-03-05 16:54:55
 * @LastEditors: ywj@originqc.com
 */
import React, { useRef } from 'react'
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import './index.scss';
import { Input } from 'antd';
import type { GetProps } from 'antd';
import searchIcon from './imgs/search.svg'
const { Search } = Input;
type SearchProps = GetProps<typeof Input.Search>;
interface ISearchProps {
  setSecondId?: any;
  setSearchName?: any;

}

export const removeUrlParams = (url: string): string => {
  return url.split('?')[0];
};
const CustomSearch: React.FC<ISearchProps> = (props) => {
  const { setSecondId, setSearchName } = props;
  const location: any = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const inputRef = useRef(null); // 创建一个 ref 来引用输入框
  const onSearch = () => {
    const inputDOM: any = inputRef.current; // 获取输入框的 DOM 元素
    if (inputDOM) {
      const value = inputDOM?.input.value; // 通过 ref 获取输入框的值
      console.log(inputDOM.input.value, value, 'value');
      if (location?.pathname.includes('/shop/search')) { //搜索页搜索
        setSecondId(null);
        setSearchName(value);
        // Set URL parameters
        searchParams.set('name', '');
        searchParams.set('categoryId', '');
        setSearchParams(searchParams);
        navigate(`/shop/search?keyword=${encodeURIComponent(value)}`);
      } else { //首页搜索
        window.open(`/shop/search?keyword=${encodeURIComponent(value)}`);
      }
    }



  };
  return (
    <div className='custom-search-container'>
      <Input
        ref={inputRef} // 将 ref 绑定到输入框
        placeholder="请输入商品关键词"
        // onChange={onSearch}
        className='search-input'
        suffix={<img src={searchIcon} alt='search' style={{ width: '50px', height: '26px', cursor: 'pointer' }} onClick={onSearch} />}
        // enterButton={<img src={searchIcon} alt='search' style={{ width: '50px', height: '50px' }} />}
        onPressEnter={ onSearch}
      />
    </div>
  )
}

export default CustomSearch;